/**
 * FAZ-2: Stripe.js loader — publishable key /api/payments/config'ten (bir kez, module-cache).
 * pk public-guvenli; test->live rebuild YOK (backend secret degisince pk otomatik gelir).
 */
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import { API } from './apiConfig';

let _stripePromise = null;

export function getStripePromise() {
  if (!_stripePromise) {
    _stripePromise = axios
      .get(`${API}/payments/config`)
      .then((r) => {
        const pk = r?.data?.publishable_key;
        return pk ? loadStripe(pk) : null;
      })
      .catch(() => null);
  }
  return _stripePromise;
}
